
import React from 'react';
import { Flex, Row } from 'antd';
import { VerifiedOutlined, BankOutlined, FieldStringOutlined, TeamOutlined, } from '@ant-design/icons';
import NavItem from '../../../components/nav-item';

const iconStyle = {
  fontSize: 28,
}
const Index = () => {
  return (
    <div>
        <Row gap={20} style={{ margin: '10px 0 0 0' }}>
            <NavItem href="/sys/mini-manage" text="代码管理">
                <FieldStringOutlined style={iconStyle} />
            </NavItem>

            <NavItem href="/sys/join" text="租户审核">
                <VerifiedOutlined style={iconStyle} />
            </NavItem>

            <NavItem href="/sys/account" text="租户管理">
                <TeamOutlined style={iconStyle} />
            </NavItem>

            <NavItem href="/sys/cash-out" text="提现管理">
                <BankOutlined style={iconStyle} />
            </NavItem>
        </Row>
    </div>
  )
}

export default Index;